import { isEqual, get } from 'lodash';

import { IBaseEntityType, EntityId } from '../types';
import {
  TRANSFER_GROUP_AUTO_RESTOCK_TYPE,
  GROUP_AUTO_RESTOCK_ROUTE,
} from '../services/transfer-group-auto-restock/transfer-group-auto-restock.constants';

const isGroupAutoRestockPage = (data: IBaseEntityType): boolean => {
  return isEqual(
    get(data, 'transfer_group_type', null),
    TRANSFER_GROUP_AUTO_RESTOCK_TYPE,
  );
};

const buildGroupAutoRestockPagePath = (id: EntityId): string => {
  return `${GROUP_AUTO_RESTOCK_ROUTE}/${id}`;
};

export { isGroupAutoRestockPage, buildGroupAutoRestockPagePath };
